// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38_18","colMin":"styles_colMin__1KpN7"};